<template>
  <div>
    <div class="vx-row min-h-screen">
      <div class="vx-col w-full">
        <header-public></header-public>
      </div>
      <div class="vx-col w-full legal-text">
        <div class="container w-full max-w-5xl mx-auto px-3 py-12">
          <div class="vx-row">
            <div class="vx-col w-full">
              <a href="/" class="link-back">{{ $t('GoHome') }}</a>
              <h1>{{ $t('TerminosYCondicionesApp') }}</h1>
              <h2>1. Barify</h2>
              <p>
                {{ $t('privacyPolicy.Text1_1') }}
              </p>
              <p>
                {{ $t('privacyPolicy.Text1_2') }}
              </p>
              <p>
                {{ $t('privacyPolicy.Text1_3') }}
              </p>
              <p>
                {{ $t('privacyPolicy.Text1_4') }}
              </p>
              <p>
                {{ $t('privacyPolicy.Text1_5') }}
              </p>
              <p>
                {{ $t('privacyPolicy.Text1_6') }}
              </p>
              <p>
                {{ $t('privacyPolicy.Text1_7') }}
              </p>
              <h2>{{ $t('privacyPolicy.Text2') }}</h2>
              <p>
                {{ $t('privacyPolicy.Text2_1') }}
              </p>
              <p>
                {{ $t('privacyPolicy.Text2_2') }}
              </p>
              <ul>
                <li>{{ $t('privacyPolicy.Text2_3') }}</li>
                <li>
                  {{ $t('privacyPolicy.Text2_4') }}
                </li>
                <li>
                  {{ $t('privacyPolicy.Text2_5') }}
                </li>
              </ul>
              <p>
                {{ $t('privacyPolicy.Text2_6') }}
              </p>
              <p>
                {{ $t('privacyPolicy.Text2_7') }}
              </p>
              <p>
                {{ $t('privacyPolicy.Text2_8') }}
              </p>
              <p>
                {{ $t('privacyPolicy.Text2_9') }}
              </p>
              <p>
                {{ $t('privacyPolicy.Text2_10') }}
              </p>
              <p>
                {{ $t('privacyPolicy.Text2_11') }}
              </p>
              <p>
                {{ $t('privacyPolicy.Text2_12') }}
              </p>
              <h2>{{ $t('privacyPolicy.Text3') }}</h2>
              <p>
                {{ $t('privacyPolicy.Text3_1') }}
              </p>
              <p>
                {{ $t('privacyPolicy.Text3_2') }}
              </p>
              <p>
                {{ $t('privacyPolicy.Text3_3') }}
              </p>
              <h2>{{ $t('privacyPolicy.Text4') }}</h2>
              <p>
                {{ $t('privacyPolicy.Text4_1') }}
              </p>
              <h2>{{ $t('privacyPolicy.Text5') }}</h2>
              <p>
                {{ $t('privacyPolicy.Text5_1') }}
              </p>
              <p>
                {{ $t('privacyPolicy.Text5_2') }}
              </p>
              <p>{{ $t('privacyPolicy.Text5_3') }}</p>
              <h2>{{ $t('privacyPolicy.Text6') }}</h2>
              <p>
                {{ $t('privacyPolicy.Text6_1') }}
              </p>
              <p>
                {{ $t('privacyPolicy.Text6_2') }}
              </p>
              <p>
                {{ $t('privacyPolicy.Text6_3') }}
              </p>
              <p>
                {{ $t('privacyPolicy.Text6_4') }}
              </p>
              <p>
                {{ $t('privacyPolicy.Text6_5') }}
              </p>
              <p>
                {{ $t('privacyPolicy.Text6_6') }}
              </p>
              <p>
                {{ $t('privacyPolicy.Text6_7') }}
              </p>
              <p>
                {{ $t('privacyPolicy.Text6_8') }}
              </p>
              <p>
                {{ $t('privacyPolicy.Text6_9') }}
              </p>
              <p>
                {{ $t('privacyPolicy.Text6_10') }}
              </p>
              <p>
                {{ $t('privacyPolicy.Text6_11') }}
              </p>
              <h2>{{ $t('privacyPolicy.Text7') }}</h2>
              <p>
                {{ $t('privacyPolicy.Text7_1') }}
              </p>
              <p>
                {{ $t('privacyPolicy.Text7_2') }}
              </p>
              <p>
                {{ $t('privacyPolicy.Text7_3') }}
              </p>
              <p>
                {{ $t('privacyPolicy.Text7_4') }}
              </p>
              <p>
                {{ $t('privacyPolicy.Text7_5') }}
              </p>
              <ul>
                <li>
                  {{ $t('privacyPolicy.Text7_6') }}
                </li>
                <li>
                  {{ $t('privacyPolicy.Text7_7') }}
                </li>
                <li>
                  {{ $t('privacyPolicy.Text7_8') }}
                </li>
                <li>
                  {{ $t('privacyPolicy.Text7_9') }}
                </li>
                <li>
                  {{ $t('privacyPolicy.Text7_10') }}
                </li>
              </ul>
              <p>
                {{ $t('privacyPolicy.Text7_11') }}
              </p>
              <p>
                {{ $t('privacyPolicy.Text7_12') }}
              </p>
              <h2>{{ $t('privacyPolicy.Text8') }}</h2>
              <p>
                {{ $t('privacyPolicy.Text8_1') }}
              </p>
              <p>
                {{ $t('privacyPolicy.Text8_2') }}
              </p>
              <h2>{{ $t('privacyPolicy.Text9') }}</h2>
              <p>
                {{ $t('privacyPolicy.Text9_1') }}
              </p>
              <p>
                {{ $t('privacyPolicy.Text9_2') }}
              </p>
              <h2>{{ $t('privacyPolicy.Text10') }}</h2>
              <p>
                {{ $t('privacyPolicy.Text10_1') }}
              </p>
              <p>
                {{ $t('privacyPolicy.Text10_2') }}
              </p>
              <p>
                {{ $t('privacyPolicy.Text10_3') }}
              </p>
              <p>
                {{ $t('privacyPolicy.Text10_4') }}
              </p>
              <h2>{{ $t('privacyPolicy.Text11') }}</h2>
              <p>
                {{ $t('privacyPolicy.Text11_1') }}
              </p>
              <p>
                {{ $t('privacyPolicy.Text11_2') }}
              </p>
              <p>
                {{ $t('privacyPolicy.Text11_3') }}
              </p>
              <p>
                {{ $t('privacyPolicy.Text11_4') }}
              </p>
              <p>
                {{ $t('privacyPolicy.Text11_5') }}
              </p>
              <p>
                {{ $t('privacyPolicy.Text11_6') }}
              </p>
              <p>{{ $t('privacyPolicy.Text11_7') }}</p>
              <ul>
                <li>
                  {{ $t('privacyPolicy.Text11_8') }}
                </li>
                <li>
                  {{ $t('privacyPolicy.Text11_9') }}
                </li>
                <li>{{ $t('privacyPolicy.Text11_10') }}</li>
                <li>{{ $t('privacyPolicy.Text11_11') }}</li>
                <li>
                  {{ $t('privacyPolicy.Text11_12') }}
                </li>
                <li>{{ $t('privacyPolicy.Text11_13') }}</li>
              </ul>
              <p>
                {{ $t('privacyPolicy.Text11_14') }}
              </p>
              <h2>{{ $t('privacyPolicy.Text12') }}</h2>
              <p>
                {{ $t('privacyPolicy.Text12_1') }}
              </p>
              <h2>{{ $t('privacyPolicy.Text13') }}</h2>
              <p>
                {{ $t('privacyPolicy.Text13_1') }}
              </p>
              <h2>{{ $t('privacyPolicy.Text14') }}</h2>
              <p>
                {{ $t('privacyPolicy.Text14_1') }}
              </p>
              <p>
                {{ $t('privacyPolicy.Text14_2') }}
              </p>
              <p>
                {{ $t('privacyPolicy.Text14_3') }}
              </p>
              <p>
                {{ $t('privacyPolicy.Text14_4') }}
              </p>
              <p>
                {{ $t('privacyPolicy.Text14_5') }}
              </p>
              <p>
                {{ $t('privacyPolicy.Text14_6') }} SERVIPYME NEWTECH S.L. – c/ Peris y Valero 166, Primero, 46006, Valencia –
                info@servipyme.es
              </p>
              <h2>{{ $t('privacyPolicy.Text15') }}</h2>
              <p>
                {{ $t('privacyPolicy.Text15') }}
              </p>
              <a href="/" class="link-back">{{ $t('GoHome') }}</a>
            </div>
          </div>
        </div>
      </div>
      <div class="vx-col w-full self-end">
        <footer-public></footer-public>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderPublic from '../../components/Public/Header';
import FooterPublic from '../../components/Public/Footer';

export default {
  components: {
    HeaderPublic,
    FooterPublic,
  },
  data () {
    return {};
  },
};
</script>

<style>
ol,
ul {
  list-style-type: circle;
}
[dir] ol,
[dir] ul {
  margin: 25px;
  padding: 0;
}
</style>
